var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_62236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20473 15.7924C5.3392 21.3975 10.1383 23.688 15.5961 22.225C20.6225 20.8918 23.3603 15.8567 20.958 10.9001C17.1144 2.9912 13.4433 1.4049 8.56185 3.23459C3.68043 5.06429 0.741846 9.33547 3.20473 15.7924Z",
    fill: "#F4BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99024 17.4744C3.68661 16.9284 3.42029 16.3625 3.1931 15.7806C1.3088 10.8221 2.59697 7.1543 5.50945 4.89359C9.33284 9.79775 7.73046 14.3003 3.99024 17.4744Z",
    fill: "#141719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28787 7.72092C3.28787 7.72092 14.3107 9.03199 16.7921 5.36357C18.519 2.81304 13.4177 1.72815 10.4037 2.52034C8.35536 3.05027 4.25274 4.61992 3.28787 7.72092Z",
    fill: "#141719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0233 13.8535C18.1897 14.6674 17.0844 14.9958 17.0844 14.9958",
    stroke: "#CC7567",
    strokeWidth: 0.778129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5138 18.0864C16.3681 18.6704 16.0135 19.2251 15.2594 19.3482C14.9667 19.4001 14.6658 19.3813 14.3819 19.2932C14.0979 19.2052 13.8391 19.0505 13.6271 18.8421C14.5205 18.377 15.5071 18.1187 16.5138 18.0864Z",
    fill: "#F97D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9252 16.4253C16.0558 16.4394 16.1795 16.4913 16.281 16.5747C16.3824 16.6581 16.4573 16.7694 16.4963 16.8948C16.6053 17.2796 16.6108 17.6864 16.5121 18.0739C15.51 18.0962 14.5271 18.3529 13.642 18.8234C13.062 18.3056 12.7796 17.8167 12.9967 17.5231C13.834 16.3205 15.2379 16.3326 15.9252 16.4253Z",
    fill: "#CC4744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 10.6828C17.2803 10.6828 17.5527 9.53441 18.3408 9.74421",
    stroke: "#141719",
    strokeWidth: 0.778129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9517 10.4879C18.0061 10.5531 18.0729 10.6067 18.1483 10.6456C18.2237 10.6844 18.3062 10.7078 18.3908 10.7143C18.4754 10.7209 18.5604 10.7104 18.6409 10.6835C18.7213 10.6566 18.7956 10.6138 18.8593 10.5578C18.9757 10.4344 19.0407 10.2713 19.0409 10.1017C19.0411 9.93206 18.9765 9.76876 18.8603 9.64517C18.749 9.5154 18.5907 9.43517 18.4202 9.42213C18.2497 9.40909 18.081 9.46429 17.9513 9.57561C17.7036 9.7909 17.7132 10.2106 17.9517 10.4879Z",
    fill: "#141719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9367 13.8459C10.9367 13.8459 11.2092 12.6975 11.9969 12.9058",
    stroke: "#141719",
    strokeWidth: 0.778129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.612 13.6363C11.7235 13.7657 11.8819 13.8456 12.0523 13.8583C12.2227 13.8711 12.3912 13.8157 12.5208 13.7043C12.6361 13.5802 12.6997 13.4167 12.6984 13.2473C12.6972 13.0779 12.6312 12.9154 12.514 12.7931C12.4597 12.728 12.3928 12.6744 12.3174 12.6355C12.242 12.5966 12.1596 12.5732 12.075 12.5667C11.9904 12.5602 11.9054 12.5707 11.8249 12.5976C11.7445 12.6245 11.6702 12.6672 11.6065 12.7233C11.3483 12.934 11.3562 13.3444 11.612 13.6363Z",
    fill: "#141719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2962 8.34346C16.2962 8.34346 16.5221 7.81731 17.3125 7.44531",
    stroke: "#141719",
    strokeWidth: 0.778129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6668 11.0386C9.8706 10.8856 10.1041 10.7769 10.3524 10.7193C10.6007 10.6618 10.8582 10.6568 11.1086 10.7046",
    stroke: "#141719",
    strokeWidth: 0.778129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34973 12.2868C5.15787 13.6771 6.10012 17.1366 6.0558 20.1855C4.78282 18.9586 3.80737 17.4567 3.20405 15.7948C2.75733 14.6709 2.46978 13.4902 2.34973 12.2868Z",
    fill: "#141719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83451 15.3287C7.36334 16.5488 6.91942 17.8968 5.84035 18.3673C4.76129 18.8378 3.45311 18.2508 2.9256 17.0466C2.39809 15.8425 2.84069 14.4786 3.91975 14.0081C4.99882 13.5376 6.307 14.1245 6.83451 15.3287Z",
    fill: "#F4BA92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00223 15.6495C4.00223 15.6495 4.38124 14.7721 5.20138 15.462C5.72851 16.2093 4.95514 16.6912 4.95514 16.6912C5.04987 16.848 5.18782 16.9742 5.35247 17.0547C5.51712 17.1351 5.70147 17.1664 5.88344 17.1447",
    stroke: "#CC7567",
    strokeWidth: 0.830533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79762 3.94572C6.79762 3.94572 10.4955 0.542042 12.4436 0.571581C14.3917 0.60112 13.9724 2.53723 13.5531 3.18789C13.1339 3.83856 6.79762 3.94572 6.79762 3.94572Z",
    fill: "#141719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_62236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.b1f940e8ca44f06fdd7fa628cab4036b.svg";
export { ForwardRef as ReactComponent };